import React, { useEffect, useRef, useState } from "react";
import arrowDown from '../assets/arrowDown.svg'
import { AiOutlineSearch } from "react-icons/ai";
import categoryIcon from '../assets/category.svg'

const RateCategorySelector = ({

    icon = true,
    customstyle = false,
    page,
    categoryError,
    setCategoryError,
    categoryData,
    handleCategorySelect,
    device,
    placeholder,
    selectedCategory,
    disabled // NEW: Disabled prop

}) => {
    const [inputValue, setInputValue] = useState("");
    const [selected, setSelected] = useState(selectedCategory || "");
    const [open, setOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleOpen = () => {
        if (!disabled) setOpen(!open); // Prevent opening if disabled
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        setSelected(selectedCategory || "");
    }, [selectedCategory]);

    return (
        <div
            className={`w-full relative cursor-pointer `}
            ref={dropdownRef}
        >
            {/* <div
                onClick={handleOpen}
                className={`w-full h-[45px]  ${customstyle?'px-[18px] md:px-[20px] lg:px-[29px] lg:h-[50px]':'shadow-search px-[13px] mg:h-[50px]'} md:shadow-none ${categoryError === "Category is required" || categoryError === "Invalid Search"
                        ? "bg-[#FFDFE4] border-solid border-[1px] border-[#EB0728]"
                        : customstyle || disabled ?'bg-ravbg':" md:rounded-none bg-white border border-ravgray md:border-none "
                    } rounded-[80px] py-[14px]  flex items-center justify-between text-center font-medium text-base lg:text-sm ${!selected && "text-[#707070]"
                    } ${disabled ? "bg-ravbg cursor-not-allowed text-ravash" : ""}`}
            > */}
            <div
                onClick={handleOpen}
                className={`w-full h-[45px]  ${customstyle ? 'lg:h-[50px]' : ' xl:h-[50px] md:border-none '}   font-medium text-base lg:text-sm ${categoryError === "Category is required" || categoryError === "Invalid Search"
                    ? " border border-[#EB0728] "
                    : customstyle || disabled ? 'border border-[#C1C1C180] ' : "bg-white shadow-search  md:shadow-none border border-ravgray md:border-none"
                    } rounded-[80px]  py-[14px] ${customstyle ? ' bg-white  px-[18px] md:px-[20px] lg:px-[29px]' : 'px-[13px] md:rounded-r-none'} flex items-center justify-between text-center text-[14px] ${!selected && "text-[#707070]"
                    } ${disabled ? "cursor-not-allowed text-ravash md:rounded-l-none" : ""}`}
            >
                {selected
                    ? selected.length > 15
                        ? selected.substring(0, 15) + "..."
                        : selected
                    : <div className={`flex gap-[5px] font-normal text-base lg:text-sm placeholder:text-[#707070] ${categoryError && "text-[#EB0728]"}`}>
                        {icon ? <svg
                            xmlns="http://www.w3.org/2000/svg"
                            height="20"
                            width="20"
                            viewBox="0 -960 960 960"
                            className={`size-[20px] ${categoryError ? "text-[#EB0728]" : "text-[#707070]"}`}
                            fill="currentColor"
                        >
                            <path d="m260-520 220-360 220 360H260ZM700-80q-75 0-127.5-52.5T520-260q0-75 52.5-127.5T700-440q75 0 127.5 52.5T880-260q0 75-52.5 127.5T700-80Zm-580-20v-320h320v320H120Zm580-60q42 0 71-29t29-71q0-42-29-71t-71-29q-42 0-71 29t-29 71q0 42 29 71t71 29Zm-500-20h160v-160H200v160Zm202-420h156l-78-126-78 126Zm78 0ZM360-340Zm340 80Z" />
                        </svg>
                            : null}
                        {placeholder ? placeholder : "Category"}
                    </div>}
                {device === "small" && !disabled ?
                    <svg
                        width="13"
                        height="9"
                        viewBox="0 0 13 9"
                        xmlns="http://www.w3.org/2000/svg"
                        className={`${categoryError ? "text-[#EB0728]" : "text-[#707070]"} ${open && "rotate-180"}`}
                        fill="currentColor"
                    >
                        <path d="M6.5 8.04167L0.25 1.79167L1.36979 0.671875L6.5 5.80208L11.6302 0.671875L12.75 1.79167L6.5 8.04167Z" />
                    </svg> : null}

            </div>

            {!disabled && open && (
                <ul className="w-full shadow-input bg-white mt-2 overflow-y-auto flex flex-col absolute rounded-md z-[80] text-start h-[30vh]">
                    <div className="flex items-center px-2 sticky top-0 bg-white">
                        <AiOutlineSearch size={18} className="text-gray-700" />
                        <input
                            type="text"
                            value={inputValue}
                            onChange={(e) => setInputValue(e.target.value.toLowerCase())}
                            placeholder={placeholder || "Enter category name"}
                            className="placeholder:text-ravinput text-ravdeepblue p-2 text-base lg:text-sm  outline-none"
                        />
                    </div>
                    {categoryData
                        ?.sort((a, b) => a?.category_name?.localeCompare(b?.category_name))
                        ?.map((category) => (
                            <li
                                key={category?.category_name}
                                className={`p-2 text-sm hover:bg-sky-600 hover:text-white
                                    ${category?.category_name?.toLowerCase() === selected?.toLowerCase() && "bg-sky-600 text-white"}
                                    ${category?.category_name?.toLowerCase().startsWith(inputValue) ? "block" : "hidden"}
                                `}
                                onClick={() => {
                                    if (category?.category_name?.toLowerCase() !== selected.toLowerCase()) {
                                        setSelected(category?.category_name);
                                        handleCategorySelect(category?.category_name, category?.category_id);
                                        setOpen(false);
                                        setInputValue("");
                                    }
                                }}
                            >
                                {category?.category_name}
                            </li>
                        ))}
                </ul>
            )}
        </div>
    );
};

export default RateCategorySelector;
